import * as actions from '../../actions/hotels24actions'
import { urlParams } from '../../utils/mainUtils'
import { handleError, handleResponse, securedFetch } from '../apiUtils'
import * as urls from '../urls'

/**
 * @param {Object} params - List of path params
 * @param {number[]} params.organizationIds - Organization Ids
 */
export const h24PushYearPrices = params => (dispatch, getState) => {
    const { auth } = getState()

    dispatch(actions.h24_pushYearPricesRequest())

    securedFetch(urlParams(urls.h24PushYearPrices, params), auth, { method: 'GET' })
        .then(handleResponse)
        .then(() => dispatch(actions.h24_pushYearPricesSuccess()))
        .catch(
            handleError(
                dispatch,
                actions.h24_pushYearPricesFailure,
                'Что-то пошло не так!',
                'При отправке цен в Hotels24.ua произошла ошибка'
            )
        )
}

/**
 * @param {Object} params - List of path params
 * @param {number[]} params.organizationIds - Organization Ids
 */
export const h24PushYearRestrictions = params => (dispatch, getState) => {
    const { auth } = getState()

    dispatch(actions.h24_pushYearRestrictionsRequest())

    securedFetch(urlParams(urls.h24PushYearRestrictions, params), auth, { method: 'GET' })
        .then(handleResponse)
        .then(() => dispatch(actions.h24_pushYearRestrictionsSuccess()))
        .catch(
            handleError(
                dispatch,
                actions.h24_pushYearRestrictionsFailure,
                'Что-то пошло не так!',
                'При отправке ограничений в Hotels24.ua произошла ошибка'
            )
        )
}

/**
 * @param {Object} params - List of path params
 * @param {number} params.organizationId - Organization Id
 */
export const h24InventoryAvailability = params => (dispatch, getState) => {
    const { auth } = getState()

    dispatch(actions.h24_inventoryAvailabilityRequest())

    securedFetch(urlParams(urls.h24InventoryAvailability, params), auth, { method: 'GET' })
        .then(handleResponse)
        .then(() => dispatch(actions.h24_inventoryAvailabilitySuccess()))
        .catch(
            handleError(
                dispatch,
                actions.h24_inventoryAvailabilityFailure,
                'Что-то пошло не так!',
                'При попытке inventory доступности в Hotels24.ua произошла ошибка'
            )
        )
}


// WEBPACK FOOTER //
// ./src/api/h24Api/h24Sync.js